import {
  Label
} from "./chunk-GTDGWWPD.mjs";
import {
  HintAndErrorMessage
} from "./chunk-SDXM6H5U.mjs";

// src/label/src/label-hint-and-error-message.tsx
import { useId } from "react";
import { cx } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
var LabelHintAndError = ({
  hideLabel,
  label,
  disabled = false,
  hint,
  errorMessage,
  labelId,
  hintId,
  errorId
}) => {
  const internalLabelId = useId();
  const internalHintId = useId();
  const internalErrorId = useId();
  const hasHint = Boolean(hint);
  const hasError = Boolean(errorMessage);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cx("grid gap-1", {
        "!mb-3": hasError,
        "mb-2": !Boolean(hideLabel)
      }),
      children: [
        /* @__PURE__ */ jsx(
          Label,
          {
            disabled,
            hideLabel,
            label,
            labelId: labelId ?? internalLabelId
          }
        ),
        /* @__PURE__ */ jsx(
          HintAndErrorMessage,
          {
            disabled,
            errorId: errorId ?? internalErrorId,
            errorMessage,
            hasError,
            hasHint,
            hint,
            hintId: hintId ?? internalHintId
          }
        )
      ]
    }
  );
};

export {
  LabelHintAndError
};
